import React from 'react'
import { TextareaForm } from '../../../../components/TextareaForm/TextareaForm'

type EditDatasetDescriptionProps = {
  text: string
  onClose: () => void
}

export const EditDatasetDescription: React.FC<EditDatasetDescriptionProps> = ({ text, onClose }) => {
  const handleChangeDatasetDescription = async (text: string) => {
    onClose()
  }

  return (
    <TextareaForm
      updatedAt={new Date().toLocaleDateString() + '\n' + new Date().toLocaleTimeString()}
      submitButtonLabel="Save"
      textAreaContent={text}
      onCancel={onClose}
      onSubmit={handleChangeDatasetDescription}
    />
  )
}
